export default {
  zendesk: {
    script: '//static.zdassets.com/ekr/snippet.js?key=d76cc45e-05d6-4cb7-b23d-5560135126f3',
  },
  sentryDSN:
    'https://8575ec50803e4ead171278e3c2712f7a@o4505715306201088.ingest.us.sentry.io/4509880839700481',
}
